import React, { forwardRef, useEffect } from 'react';

const stopWheel = (e) => {
    e = e || window.event;
    e.preventDefault();
    e.returnValue = false;
};

const ScrollableArea = forwardRef(
    (
        {
            id = 'scrollable-area',
            height = 'max-content',
            width = 'max-content',
            scrollPx,
            onScroll,
            scrollableLength,
            isHorizontal = false,
            maxVisibleLength = isHorizontal ? width : height,
            grabberSize = 63,
            scrollSpeed = 4,
            ...props
        },
        ref
    ) => {
        const onWheel = (e) => {
            if (typeof onScroll !== 'function') return;

            document.addEventListener('wheel', stopWheel, { passive: false });
            // Prevent the browser from scrolling the entire page
            stopWheel(e);

            const newPx =
                scrollPx +
                ((!isHorizontal && e.deltaY > 0) ||
                (isHorizontal && e.deltaY < 0)
                    ? scrollSpeed
                    : -scrollSpeed);

            if (newPx < 0) {
                onScroll(0);
            } else if (newPx >= scrollableLength - maxVisibleLength) {
                onScroll(scrollableLength - maxVisibleLength);
            } else {
                onScroll(newPx);
            }

            document.removeEventListener('wheel', stopWheel, {
                passive: false
            });
        };

        useEffect(() => {
            if (ref?.current && scrollableLength - 1 > maxVisibleLength) {
                /* Adding the event this way allows setting manual setting of
                 * the 'passive' option, otherwise unimplemented in react's upstream.
                 * This fixes `e.preventDefault();` not working in chrome. */
                ref.current.addEventListener('wheel', onWheel, {
                    passive: false
                });
            }
            return () => {
                if (ref?.current) {
                    ref.current.removeEventListener('wheel', onWheel, {
                        passive: false
                    });
                }
            };
        }, [ref?.current, scrollPx, scrollableLength, height]);

        return (
            <div
                {...props}
                id={id}
                ref={ref}
                style={{
                    display: 'block',
                    [`overflow${isHorizontal ? 'X' : 'Y'}`]: 'hidden',
                    height: height,
                    width: width,
                    ...props.style
                }}
            />
        );
    }
);

ScrollableArea.displayName = 'ScrollableArea';

export default ScrollableArea;
